var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignals = function SvgSignals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.002 8.148a1.1 1.1 0 1 1 0-2.2 1.1 1.1 0 0 1 0 2.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.002 14a.55.55 0 0 1-.55-.55V8.148a.55.55 0 1 1 1.1 0v5.302a.55.55 0 0 1-.55.55M9.949 9.545a.55.55 0 0 1-.391-.94 2.2 2.2 0 0 0 0-3.108.55.55 0 1 1 .776-.781 3.3 3.3 0 0 1 0 4.67.55.55 0 0 1-.385.159M6.055 9.545a.55.55 0 0 1-.385-.16 3.3 3.3 0 0 1 0-4.669.55.55 0 1 1 .775.781 2.2 2.2 0 0 0 0 3.108.55.55 0 0 1-.39.94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.5 11.102a.55.55 0 0 1-.386-.941 4.4 4.4 0 0 0 0-6.22.549.549 0 0 1 .388-.941.55.55 0 0 1 .388.16 5.5 5.5 0 0 1 0 7.782.55.55 0 0 1-.39.16M4.504 11.102a.55.55 0 0 1-.39-.16 5.5 5.5 0 0 1 0-7.782.55.55 0 1 1 .775.78 4.4 4.4 0 0 0 0 6.21.55.55 0 0 1-.385.94z"
  })));
};
export { SvgSignals as ReactComponent };
export default __webpack_public_path__ + "d47014a071b176e27a583e069bf72eb9.svg";